import React from 'react'
import PropTypes from 'prop-types'

const ReGenerateIcon = (props) => {
  const {
    color = '#00B2AD',
    classes = 'w-20',
    backgroundColor = 'none',
  } = props
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill={backgroundColor}
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M4.00002 24.5H1.66669V17.5H8.66669V19.8333H5.77335C7.65169 22.645 10.86 24.5 14.5 24.5C20.2984 24.5 25 19.7983 25 14H27.3334C27.3334 21.0933 21.5934 26.8333 14.5 26.8333C10.16 26.8333 6.32169 24.675 4.00002 21.385V24.5ZM1.66669 14C1.66669 6.90663 7.40669 1.16663 14.5 1.16663C18.84 1.16663 22.6784 3.32496 25 6.61496V3.49996H27.3334V10.5H20.3334V8.16663H23.2267C21.3484 5.35496 18.14 3.49996 14.5 3.49996C8.70169 3.49996 4.00002 8.20163 4.00002 14H1.66669Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.561 14.1544C11.8576 14.0498 12.0877 13.8118 12.1822 13.5119L12.7983 11.557C12.8446 11.41 12.9809 11.31 13.1351 11.31C13.2892 11.31 13.4256 11.41 13.4719 11.557L14.088 13.5119C14.1825 13.8118 14.4126 14.0498 14.7092 14.1544L16.5118 14.79C16.6666 14.8446 16.7702 14.9908 16.7702 15.155C16.7702 15.3191 16.6666 15.4654 16.5118 15.52L14.7092 16.1556C14.4126 16.2602 14.1825 16.4982 14.088 16.7981L13.4719 18.753C13.4256 18.9 13.2892 19 13.1351 19C12.9809 19 12.8446 18.9 12.7983 18.753L12.1822 16.7981C12.0877 16.4982 11.8576 16.2602 11.561 16.1556L9.75834 15.52C9.60354 15.4654 9.5 15.3191 9.5 15.155C9.5 14.9908 9.60354 14.8446 9.75834 14.79L11.561 14.1544Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3382 10.5451C16.6348 10.4405 16.8649 10.2025 16.9594 9.90252L17.166 9.247C17.2123 9.09998 17.3487 9 17.5028 9C17.6569 9 17.7933 9.09998 17.8396 9.247L18.0462 9.90252C18.1407 10.2025 18.3708 10.4405 18.6674 10.5451L19.2417 10.7475C19.3965 10.8021 19.5 10.9484 19.5 11.1125C19.5 11.2767 19.3965 11.423 19.2417 11.4776L18.6674 11.68C18.3708 11.7846 18.1407 12.0226 18.0462 12.3225L17.8396 12.9781C17.7933 13.1251 17.6569 13.2251 17.5028 13.2251C17.3487 13.2251 17.2123 13.1251 17.166 12.9781L16.9594 12.3225C16.8649 12.0226 16.6348 11.7846 16.3382 11.68L15.7639 11.4776C15.6091 11.423 15.5056 11.2767 15.5056 11.1125C15.5056 10.9484 15.6091 10.8021 15.7639 10.7475L16.3382 10.5451Z"
        fill={color}
      />
    </svg>
  )
}

ReGenerateIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ReGenerateIcon)
